import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { deleteCategory, getCategoryData, updateCategory } from "./Catagory.action";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from 'material-table';
import jsPDF from "jspdf";
const tableRef = React.createRef()


const CategoryTableList = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"))
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
    }

    useEffect(() => {
        props.setHeading("Category List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    title="Category List"
                    columns={[
                        { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Company', field: 'retaurantId.restaurantName', editable: 'never' },
                        { title: 'Category', field: 'name' },
                        { title: 'Created At', field: 'createdAt', type: 'date', editable: 'never', dateSetting: { locale: "en-GB" } },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/categories?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: 'GET',
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "p";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Category Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.retaurantId.restaurantName,
                                elt.name,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Category Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Category Edit"),
                        isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Category Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.updateCategory(newData, oldData)
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.deleteCategory(oldData._id);
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        }
                    ]}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        getCategoryData: () => dispatch(getCategoryData()),
        deleteCategory: (_Id) => dispatch(deleteCategory(_Id)),
        updateCategory: (newData, oldData) => dispatch(updateCategory(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingcategoryList: state.CategoryReducer.isFetchingcategoryList,
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryTableList);